import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-unsupported-browser',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['./unsupported-browser.component.scss'],
})
export class UnsupportedBrowserComponent {
  readonly browsers = [
    { name: 'Google Chrome', url: 'https://www.google.com/chrome/' },
    { name: 'Mozilla Firefox', url: 'https://www.mozilla.org/firefox/new/' },
    { name: 'Microsoft Edge', url: 'https://www.microsoft.com/edge' },
    { name: 'Safari', url: 'https://support.apple.com/downloads/safari' },
  ];
}
